<template>
  <div v-if="bannerList?.length" class="japan-top-banner">
    <WphkBanner :class="['main-banner']" type="swiper" :bannerList="bannerList" :isMultBrow="false" />
  </div>
</template>

<script setup lang="ts">
import { onBeforeMount, ref } from 'vue';
import { useConfigStore } from '@/store';
import WphkBanner, { BannerConfig } from '@tencent/wphk-components-banner';
import { ModuleName } from '@/types/module-type';

const props = defineProps<{ moduleName: ModuleName }>();
const emit = defineEmits(['onHideModule']);

const { getConfig } = useConfigStore();
const bannerList = ref<BannerConfig[]>();

onBeforeMount(async () => {
  const { bannerList: bannerListVal = [] } = await getConfig(props.moduleName);
  if (bannerListVal.length) {
    bannerList.value = bannerListVal;
  } else {
    emit('onHideModule', ModuleName.JapanTopBanner);
  }
});
</script>

<style lang="less" scoped>
@import (reference) '~@/less/main.less';
@import (reference) '~@tencent/wphk-design-theme/index.less';
.japan-top-banner {
  margin-top: @space-space-070;
  margin-bottom: @space-space-030;
  border-radius: @radius-radius-040;
  overflow: hidden;
  /deep/ .main-banner {
    border-radius: @radius-radius-040;
    overflow: hidden;
    img {
      border-radius: @radius-radius-040;
    }
  }
}
</style>
